import {
  ActionArm,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionGripper,
  ActionInspection,
  ActionLand,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  CameraGimbal,
  CameraLiveView,
  CameraShoot,
  CameraSetAutoShoot,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAltHold,
  ModeAuto,
  ModeBrake,
  ModeGuided,
  ModeLoiter,
  ModePosHold,
  ModeRTL,
  ModeStabilize,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Mode',
    commands: [ModeGuided, ModeStabilize, ModeAuto, ModeLoiter, ModeBrake, ModeAltHold, ModePosHold, ModeRTL],
  },
  {
    name: 'Action',
    commands: [
      ActionInspection,
      ActionArm,
      ActionDisarm,
      ActionTakeoff,
      ActionGoto,
      ActionElevate,
      ActionStickControl,
      ActionLand,
      ActionGripper,
      ActionSetServo,
    ],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraGimbal, CameraShoot, CameraSetAutoShoot],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
